import template from './apps.html';
import controller from './apps.controller';
import './apps.scss';

let appsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default appsComponent;



// WEBPACK FOOTER //
// ./client/app/components/apps/apps.component.js